module.exports = __webpack_public_path__ + "static/media/Hero_Mobile.2701d5e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Hero_Mobile.jpg
// module id = 219
// module chunks = 8